import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const ElectronicsLeague = () => {
  return (
    <SportsLayoutComp name={'Electronics League'}/>
  )
}

export default ElectronicsLeague